export default __webpack_public_path__ + "static/media/pizza7.ee47a5b2.png";